import PermanentWallets from './PermanentWallets';

export default PermanentWallets;
